import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { SizeDataTypeInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialSizeDataType: Partial<SizeDataTypeInterface> = {
  unitName: '',
  description: '',
  active: true,
};

const AdSpaceSizeDataTypesAdminAddSizeDataTypePage: React.FC = () => {
  const [sizeDataType, setSizeDataType] = useState<Partial<SizeDataTypeInterface>>(initialSizeDataType);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof SizeDataTypeInterface, value: any) => {
    setSizeDataType(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<SizeDataTypeInterface>>('/sizeDataTypes/insert', 'POST', sizeDataType);
      if (result.status) {
        setSuccess(result.message || 'Size data type created successfully!');
        setDialogOpen(true);
        setSizeDataType(initialSizeDataType);
      } else {
        setError(result.message || 'Failed to create size data type');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create size data type');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Size Data Type</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Unit Name"
          value={sizeDataType.unitName ?? ''}
          onChange={e => handleChange('unitName', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Description"
          value={sizeDataType.description ?? ''}
          onChange={e => handleChange('description', e.target.value)}
          fullWidth
          margin="dense"
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={sizeDataType.active !== undefined ? (sizeDataType.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Size Data Type
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdSpaceSizeDataTypesAdminAddSizeDataTypePage;